module.exports = __webpack_public_path__ + "img/braco-e.5b3626b5.png";